import Vue from "vue";
import { StatementModel } from "../../models/statement/statementModel";
import { CatalogStore } from "../../store/modules/catalog";
import { getModule } from "vuex-module-decorators";

export class OperationsHistoryVue extends Vue {
  /**Стор каталога */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  get model(): StatementModel {
    return this.catalogStore.operationsHistory;
  }
}
